/**
 * G5. Свадебный стол: 3 из 6 расходов; у каждого цена в долларах ППС и
 * радость; итог и шанс помощи родителей — текстом.
 */
import { t } from '@life/i18n';
import { WEDDING_HAPPINESS_BASE, WEDDING_HAPPINESS_MAX, WEDDING_PARENT_HELP_SHARE, type WeddingInput, type WeddingState } from '@life/minigames';
import { useState } from 'preact/hooks';
import { money } from '../lib/format';
import type { MinigameScreenProps } from './types';
import { Pick } from './ui/Pick';

export function Wedding({ state, onInput }: MinigameScreenProps<WeddingInput, WeddingState>) {
  const [picks, setPicks] = useState<number[]>([]);
  const total = picks.reduce((s, i) => s + (state.items[i]?.cost ?? 0), 0);
  const joy = picks.reduce((s, i) => s + (state.items[i]?.joy ?? 0), 0);

  return (
    <>
      <p class="hint">
        {t('ui.minigame.wedding.rules', {
          n: state.picks,
          total: state.items.length,
          base: WEDDING_HAPPINESS_BASE,
          max: WEDDING_HAPPINESS_MAX,
          help: Math.round(WEDDING_PARENT_HELP_SHARE * 100),
          p: Math.round(state.helpP * 100),
        })}
      </p>
      <Pick
        label={t('ui.minigame.wedding.label')}
        items={state.items.map((it) => ({ text: t(it.key), note: t('ui.minigame.wedding.item', { sum: money(it.cost), joy: it.joy }) }))}
        max={state.picks}
        value={picks}
        onChange={setPicks}
      />
      <p class="hint mono">{t('ui.minigame.wedding.total', { sum: money(total), joy: Math.min(WEDDING_HAPPINESS_MAX, WEDDING_HAPPINESS_BASE + joy), money: money(state.money) })}</p>
      <button type="button" class="btn accent block" disabled={picks.length < state.picks} onClick={() => onInput({ picks })}>
        {t('ui.minigame.wedding.confirm')}
      </button>
    </>
  );
}
